import React from 'react';
import GuidePageScreen, { generateStaticParams } from '@/components/Guides/GuidePageScreen';
export { generateStaticParams };
export default function LearnLesson() { return <GuidePageScreen guideType="learn" />; }
